import {
    Box,
    Button,
    Typography,
    TextField,
    Grid,
    MenuItem,
    Backdrop
} from '@mui/material'
import React, { ChangeEvent, FormEvent, useState } from 'react'
import FPX from '../../assets/one-click-pay/fpx.png'
import IconFPX from '../../assets/one-click-pay/icon_fpx.png'
import IconEwallet from '../../assets/one-click-pay/icon_ewallet.png'
import PaymentNormal from '../../assets/one-click-pay/payment_normal.png'
import PaymentSelect from '../../assets/one-click-pay/payment_select.png'
import { Image, message } from 'antd'
import axios from 'axios'
import { OneClickPayUrl } from '../../common/url'
import { isDesktop } from 'react-device-detect'
import ReactLoading from 'react-loading'
// import { log } from 'console'
import { useTranslation } from 'react-i18next'

export const SMOneClickPay: React.FC = () => {

    const { t } = useTranslation()
    
    // ======================= HOOKS
    const [step, setStep] = useState(1)

    const [step1Data, setStep1Data] = useState(null)

    const [paymentMethod, setPaymentMethod] = useState(1)

    const [step1Forms, setStep1Forms] = useState({
        agreementNumber: '',
        vehiclePlateNumber: ''
    })

    const [step2Forms, setStep2Forms] = useState({
        agreementNumber: '',
        name: '',
        email: '',
        amountDue: '',
        bank: '',
        paymentAmount: '',
        totalPaymentAmount: ''
    })

    const [bankList, setBankList] = useState([])

    const [selectBank, setSelectBank] = useState('')

    const [bankData, setBankData] = useState(null)

    const [paymentValue, setPaymentValue] = useState('')

    const step2Data = [
        {
            'id': 'agreementNumber',
            'title': 'Agreement Number',
            'placeholder': '',
            'select': false,
            'value': step2Forms.agreementNumber,
            'required': false,
        },
        {
            'id': 'name',
            'title': 'Name',
            'placeholder': '',
            'select': false,
            'value': step2Forms.name,
            'required': false
        },
        {
            'id': 'email',
            'title': 'Email',
            'placeholder': '',
            'select': false,
            'value': step2Forms.email,
            'required': true
        },
        {
            'id': 'amountDue',
            'title': 'Amount Due (RM)',
            'placeholder': '',
            'select': false,
            'value': step2Forms.amountDue,
            'required': false
        },
        {
            'id': 'Payment Method',
            'title': 'Payment Method',
            'placeholder': '',
            'select': false,
            'value': '',
            'required': false
        },
        {
            'id': 'Select Bank',
            'title': 'Select Bank',
            'placeholder': '',
            'select': true,
            'value': step2Forms.phone,
            'required': true
        },
        {
            'id': 'paymentAmount',
            'title': 'Payment Amount (RM)',
            'placeholder': '',
            'select': false,
            'value': step2Forms.paymentAmount,
            'required': false
        },
        {
            'id': 'totalPaymentAmount',
            'title': 'Total Payment Amount (RM)',
            'placeholder': '',
            'select': false,
            'value': step2Forms.totalPaymentAmount,
            'required': false
        }
    ]

    const [financingType, setFinancingType] = useState(0)

    const financingTypeList = [t('t442'), t('t443')]

    const [openLoading, setOpenLoading] = useState(false)

    const financingTypeSelectItem = () => (
        financingTypeList.map((item, index) => (
            financingTypeMenuItem(index)
        ))
    )

    const financingTypeMenuItem = (index: number) => {
        return (
            <MenuItem key={index} value={financingTypeList[index]} onClick={() => updateSelectFinancingType(index)}>
                {financingTypeList[index]}
            </MenuItem>
        )
    }

    const updateSelectFinancingType = (index: number) => {
        setFinancingType(index)
    }


    const bankSelectItem = () => (
        bankList.map((item, index) => (
            bankMenuItem(index)
        ))
    )

    const bankMenuItem = (index: number) => {
        return (
            <MenuItem key={index} value={bankList[index]['name']} onClick={() => updateSelectBank(index, bankList[index]['name'], bankList[index])}>
                {bankList[index]['name']}
            </MenuItem>
        )
    }

    const updateSelectBank = (index: number, text: string, data: any) => {
        if (step2Forms.paymentAmount === null || step2Forms.paymentAmount === '') {
            step2Forms.totalPaymentAmount = ''
        } else {
            var fee = parseFloat(data['fee'])
            var money = parseFloat(step2Forms.paymentAmount)
            var totalMoney = money * (1 + fee)
            step2Forms.totalPaymentAmount = String(totalMoney.toFixed(2))
        }
        setSelectBank(text)
        setBankData(data)
    }

    const handleInputChange1 = (e: ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target

        setStep1Forms((prevForms) => ({
            ...prevForms,
            [id]: value,
        }))
    }

    const handleInputChange2 = (e: ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target
        if (id === 'paymentAmount') {
            if (bankData !== null) {
                if (value === null || value === '') {
                    step2Forms.totalPaymentAmount = ''
                } else {
                    var fee = parseFloat(bankData['fee'])
                    var money = parseFloat(value)
                    var totalMoney = money * (1 + fee)
                    step2Forms.totalPaymentAmount = String(totalMoney.toFixed(2))
                }
            }
        }
        setStep2Forms((prevForms) => ({
            ...prevForms,
            [id]: value,
        }))
    }

    const paymentChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        // 使用正则表达式来判断输入是否为小数
        const decimalRegex = /^\d*\.?\d*$/
        if (decimalRegex.test(value)) {
            setPaymentValue(value)
            const { id } = e.target
            if (id === 'paymentAmount') {
                if (bankData !== null) {
                    if (value === null || value === '') {
                        step2Forms.totalPaymentAmount = ''
                    } else {
                        var fee = parseFloat(bankData['fee'])
                        var money = parseFloat(value)
                        var totalMoney = money * (1 + fee)
                        step2Forms.totalPaymentAmount = String(totalMoney.toFixed(2))
                    }
                }
            }
            setStep2Forms((prevForms) => ({
                ...prevForms,
                [id]: value,
            }))
        }


    }

    const handleSubmit1 = async (e: FormEvent) => {
        e.preventDefault()
        if (step1Forms.agreementNumber === null || step1Forms.agreementNumber === '') {
            message.destroy()
            message.open(
                {
                    type: 'error',
                    content: 'Agreement Number Cannot Be Blank.',
                    style: {
                        marginTop: '40vh',
                    },
                }
            )
            return
        }

        if (step1Forms.vehiclePlateNumber === null || step1Forms.vehiclePlateNumber === '') {
            message.destroy()
            message.open(
                {
                    type: 'error',
                    content: financingType === 0 ? 'NRIC Number Cannot Be Blank.' : 'Vehicle Plate Number Cannot Be Blank.',
                    style: {
                        marginTop: '40vh',
                    },
                }
            )
            return
        }

        var params = {
            'agreementNo': step1Forms.agreementNumber,
            'carPlate': step1Forms.vehiclePlateNumber
        }

        if (financingType === 0) {
            params = {
                'agreementNo': step1Forms.agreementNumber,
                'nric': step1Forms.vehiclePlateNumber
            }
        } else {
            params = {
                'agreementNo': step1Forms.agreementNumber,
                'carPlate': step1Forms.vehiclePlateNumber
            }
        }

        message.destroy()
        message.open({
            type: 'loading',
            content: 'loading...',
            duration: 0,
            style: {
                marginTop: '40vh',
            },
        })

        try {
            const response = await axios.post(OneClickPayUrl, params)
            if (response.status === 200) {
                message.destroy()
                const code = response.data['code']
                if (code === 200) {
                    setStep1Data(response.data['data'])
                    setBankList(response.data['data']['fpx'] === null ? [] : response.data['data']['fpx'])
                    setStep(2)
                    setStep1Forms({
                        agreementNumber: '',
                        vehiclePlateNumber: ''
                    })
                    step2Forms.email = response.data['data']['email']
                    step2Forms.amountDue = response.data['data']['paymentAmount']
                    step2Forms.paymentAmount = response.data['data']['paymentAmount']
                    setPaymentValue(response.data['data']['paymentAmount'])
                } else {
                    message.destroy()
                    message.open({
                        type: 'error',
                        content: response.data['message'],
                        style: {
                            marginTop: '40vh',
                        },
                    })
                }

            }

        } catch (error) {
            message.destroy()
            message.open({
                type: 'error',
                content: 'failed',
                style: {
                    marginTop: '40vh',
                },
            })
        }
    }

    const handleSubmit2 = async (e: FormEvent) => {
        e.preventDefault()
        // alert('agreementNumber：' + forms.agreementNumber + ',plateNumber：' + forms.plateNumber)
        if (step2Forms.email === null || step2Forms.email === '') {
            message.destroy()
            message.open(
                {
                    type: 'error',
                    content: 'Email Cannot Be Blank.',
                    style: {
                        marginTop: '40vh',
                    },
                }
            )
            return
        }

        if (selectBank === null || selectBank === '') {
            message.destroy()
            message.open(
                {
                    type: 'error',
                    content: paymentMethod === 2 ? 'Please select eWallet.' : 'Please select bank.',
                    style: {
                        marginTop: '40vh',
                    },
                }
            )
            return
        }

        if (step2Forms.paymentAmount === null || step2Forms.paymentAmount === '' || parseFloat(step2Forms.paymentAmount) === 0) {
            message.destroy()
            message.open(
                {
                    type: 'error',
                    content: 'Payment Amount Cannot Be Blank.',
                    style: {
                        marginTop: '40vh',
                    },
                }
            )
            return
        }

        var params = {
            'phone': step1Data['mobile'],
            'email': step2Forms.email,
            'totleAmount': step2Forms.totalPaymentAmount,
            'actualCurrency': step2Forms.paymentAmount,
            'poundage': String(parseFloat(step2Forms.totalPaymentAmount) - step2Forms.paymentAmount),
            'userName': step1Data['applyName'],
            'orderNo': step1Data['agreementNo'],
            'paymentId': bankData['paymentId'],
            'channel': 'Portal'
        }
        setOpenLoading(true)
        try {
            // 正式地址
            const response = await axios.post('//e-shenma.com.my/payment/enquiry', params)
            // 测试地址
            //const response = await axios.post('//sit01.e-shenma.com.my/payment/enquiry', params)
            if (response.status === 200) {
                const code = response.data['code']
                var data = response.data
                if (code === 200) {
                    const newParams = {
                        MerchantCode: data['merchantCode'],
                        PaymentId: params['paymentId'],
                        RefNo: data['refNo'],  //订单号
                        Amount: data['totleAmount'], //总金额
                        Currency: 'MYR',
                        ProdDesc: data['prodDesc'], //产品描述
                        UserName: params['userName'],
                        UserEmail: params['email'],
                        UserContact: params['phone'],
                        Remark: '',
                        Lang: 'UTF-8',
                        SignatureType: data['signatureType'],
                        Signature: data['signature'],
                        // ResponseURL: `${window.location.origin}/dashboard/payment/result?refNo=${refNo}`,
                        ResponseURL: data['responseURL'],
                        BackendURL: data['backendURL'],
                    }
                    const formEl = document.createElement('form')
                    formEl.method = 'POST'
                    formEl.action = 'https://payment.ipay88.com.my/epayment/entry.asp'
                    // formEl.target = '_blank'

                    for (const key in newParams) {
                        if (newParams.hasOwnProperty(key)) {
                            const hiddenField = document.createElement('input')
                            hiddenField.type = 'hidden'
                            hiddenField.name = key
                            hiddenField.value = newParams[key as keyof ReqPayment]

                            formEl.appendChild(hiddenField)
                        }
                    }

                    document.body.appendChild(formEl)
                    formEl.submit()
                    setTimeout(() => {
                        setOpenLoading(false)
                    }, 8000)
                }
            } else {
                setOpenLoading(false)
                message.destroy()
                message.open({
                    type: 'error',
                    content: 'failed',
                    style: {
                        marginTop: '40vh',
                    },
                })
            }
        } catch (error) {
            setOpenLoading(false)
            message.destroy()
            message.open({
                type: 'error',
                content: 'failed',
                style: {
                    marginTop: '40vh',
                },
            })
        }
    }

    const backAction = () => {
        setStep1Data(null)
        setSelectBank(null)
        setBankList([])
        setStep(1)
        setBankData(null)
        setPaymentValue('')
        setStep2Forms({
            agreementNumber: '',
            name: '',
            email: '',
            amountDue: '',
            bank: '',
            paymentAmount: '',
            totalPaymentAmount: ''
        })
        window.scrollTo({ top: 0 })
    }

    const step1Item = () => {
        return (
            <Box>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'} paddingBottom={'48px'} textAlign={'center'}>
                    One-Click Payment
                </Typography>

                <form onSubmit={handleSubmit1}>
                    <Box sx={{
                        width: '100%',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '10px',
                        alignItems: 'center',
                        boxShadow: '0px 10px 80px 3px #0000001A',
                        paddingLeft: isDesktop ? '50px' : '25px',
                        paddingRight: isDesktop ? '50px' : '25px',
                        paddingTop: '50px',
                        paddingBottom: '50px',
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                    }}>

                        {/* Financing Type */}
                        <Box sx={{ width: '100%' }}>
                            <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                                {t('t441')} <span style={{
                                    color: '#FF4D49',
                                    fontSize: '16',
                                    fontWeight: '500'
                                }}>*</span>
                            </Typography>
                            <TextField
                                select
                                fullWidth
                                variant='outlined'
                                value={financingTypeList[financingType]}
                                InputProps={{
                                    style: {
                                        height: '53px',
                                    }
                                }}
                            >
                                {financingTypeSelectItem()}
                            </TextField>
                        </Box>

                        {/* Agreement Number */}
                        <Box sx={{
                            width: '100%',
                            paddingTop: '20px',
                        }}>
                            <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                                {t('t444')} <span style={{
                                    color: '#FF4D49',
                                    fontSize: '16',
                                    fontWeight: '500'
                                }}>*</span>
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=''
                                variant='outlined'
                                id='agreementNumber'
                                onChange={handleInputChange1}
                            />
                        </Box>

                        {/* Last 4 NRIC Number */}
                        <Box sx={{
                            paddingTop: '20px',
                            width: '100%',
                        }}>
                            <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                                {financingType === 0 ? t('t445') : 'Vehicle Plate Number'} <span style={{
                                    color: '#FF4D49',
                                    fontSize: '16',
                                    fontWeight: '500'
                                }}>*</span>
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=''
                                variant='outlined'
                                id='vehiclePlateNumber'
                                onChange={handleInputChange1}
                            />
                        </Box>

                        <Box sx={{
                            paddingTop: '40px'
                        }}>
                            <Button
                                type='submit'
                                sx={{
                                    borderRadius: '30px',
                                    height: '60px',
                                    width: '200px',
                                    // paddingLeft: '36px',
                                    // paddingRight: '36px',
                                    bgcolor: '#FFC107',
                                    border: '1px solid #FFC107',
                                    color: '#141F39',
                                    '&:hover': {
                                        bgcolor: '#FFC107',
                                    },
                                    textTransform: 'none'
                                }}
                            >
                                {t('t446')}
                            </Button>
                        </Box>
                    </Box>
                </form>
            </Box>
        )
    }

    const step2Item = () => {
        return (
            <Box>
                <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'}>
                    Payment
                </Typography>

                <Typography fontSize={16} fontWeight={500} color={'#6B6B6B'} paddingTop={'16px'} paddingBottom={'48px'} textAlign={'center'}>
                    It has never been easier for you to pay installment with us.
                </Typography>

                <form onSubmit={handleSubmit2}>
                    <Box sx={{
                        width: '100%',
                        backgroundColor: '#FFFFFF',
                        borderRadius: '10px',
                        alignItems: 'start',
                        boxShadow: '0px 10px 80px 3px #0000001A',
                        paddingLeft: isDesktop ? '50px' : '25px',
                        paddingRight: isDesktop ? '50px' : '25px',
                        paddingTop: '50px',
                        paddingBottom: '50px',
                        justifyContent: 'start',
                        alignContent: 'start',
                        display: 'flex',
                        flexDirection: 'column',
                    }}>

                        <Image src={FPX} width={220} height={64} preview={false} alt=''></Image>

                        <Box sx={{ paddingTop: '40px' }}>
                            <Grid container columnSpacing={3} rowSpacing={2}>
                                {step2Data.map((item, index) => (
                                    step2Data[index]['id'] === 'Payment Method' ? paymentMethodItem() : renderInputItem(step2Data[index]['select'], index, step2Data[index]['title'], step2Data[index]['placeholder'], step2Data[index]['id'], step2Data[index]['value'], step2Data[index]['required'])
                                ))}
                            </Grid>
                        </Box>

                        <Box sx={{
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                        }}>

                            <Button
                                onClick={() => backAction()}
                                sx={{
                                    borderRadius: '30px',
                                    mt: 6,
                                    bgcolor: '#FFFFFF',
                                    color: '#141F39',
                                    '&:hover': {
                                        bgcolor: '#FFC107',
                                    },
                                    border: '1px solid #141F39',
                                    height: '60px',
                                    paddingLeft: '25px',
                                    paddingRight: '25px',
                                    textTransform: 'none',
                                }}
                            >
                                Back
                            </Button>

                            <Button
                                type='submit'
                                sx={{
                                    borderRadius: '30px',
                                    mt: 6,
                                    bgcolor: '#FFC107',
                                    color: '#141F39',
                                    '&:hover': {
                                        bgcolor: '#FFC107',
                                    },
                                    height: '60px',
                                    paddingLeft: '50px',
                                    paddingRight: '50px',
                                    textTransform: 'none',
                                }}
                            >
                                Proceed
                            </Button>
                        </Box>
                    </Box>
                </form>
            </Box>
        )
    }

    const renderInputItem = (select: boolean, index: number, title: string, placeholder: string, id: string, value: string, required: boolean) => {
        var disabled = true
        var defaultValue = ''
        if (step1Data !== null) {
            if (index === 0) {
                defaultValue = step1Data['agreementNo']
            } else if (index === 1) {
                defaultValue = step1Data['applyName']
            } else if (index === 2) {
                disabled = false
                defaultValue = step1Data['email']
            } else if (index === 3) {
                defaultValue = step1Data['paymentAmount']
            } else if (index === 4) {

            } else if (index === 5) {

            } else if (index === 6) {
                disabled = false
            } else if (index === 7) {
                defaultValue = step2Forms.totalPaymentAmount
            }
        }

        var item
        if (index === 6) {
            item = <TextField
                fullWidth
                placeholder={placeholder}
                variant='outlined'
                id={id}
                value={paymentValue}
                disabled={disabled}
                className={id}
                onChange={paymentChange}
                type={'text'}
                InputProps={{
                    inputMode: 'decimal',
                    pattern: '[0-9]*[.,][0-9]*',
                    style: {
                        height: '53px',
                    }
                }}
            />
        } else {
            item = (index === 7 ? <TextField
                fullWidth
                placeholder={placeholder}
                variant='outlined'
                id={id}
                value={defaultValue === null ? '' : defaultValue}
                disabled={disabled}
                className={id}
                InputProps={{
                    style: {
                        height: '53px',
                    }
                }}
            /> : <TextField
                fullWidth
                placeholder={placeholder}
                variant='outlined'
                id={id}
                defaultValue={defaultValue === null ? '' : defaultValue}
                disabled={disabled}
                className={id}
                onChange={handleInputChange2}
                InputProps={{
                    style: {
                        height: '53px',
                    }
                }}
            />)
        }

        return (
            <Grid item key={index.toString() + id} xs={isDesktop ? 6 : 12}>
                <Box sx={{
                    width: '100%',
                }}>
                    <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                        {(index === 5 && paymentMethod === 2) ? 'Select eWallet' : title} {required ? (<span style={{
                            color: '#FF4D49',
                            fontSize: '16',
                            fontWeight: '500'
                        }}>*</span>) : null}
                    </Typography>
                    {
                        select === true ?
                            (<TextField
                                select
                                fullWidth
                                variant='outlined'
                                value={selectBank === null ? '' : selectBank}
                                InputProps={{
                                    style: {
                                        height: '53px',
                                    }
                                }}
                            >
                                {bankSelectItem()}
                            </TextField>) :
                            item
                    }
                </Box>
            </Grid>
        )
    }

    const paymentMethodItem = () => {
        return (
            <Grid item key={'Grid Payment Method'} xs={isDesktop ? 6 : 12}>
                <Box>
                    <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingBottom={'12px'}>
                        Payment Method  <span style={{
                            color: '#FF4D49',
                            fontSize: '16',
                            fontWeight: '500'
                        }}>*</span>
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={() => fpxAction()}>
                        <Image src={paymentMethod === 1 ? PaymentSelect : PaymentNormal} width={16} height={16} preview={false} alt=''></Image>
                        <Box sx={{ paddingLeft: '8px' }}>
                            <Image src={IconFPX} preview={false} width={52} height={24} alt=''></Image>
                        </Box>
                        <Typography fontSize={14} fontWeight={400} color={'#6B6B6B'} paddingLeft={'8px'}>
                            Online Banking - FPX
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'row', paddingTop: '12px', alignItems: 'center' }} onClick={() => ewalletAction()} >
                        <Image src={paymentMethod === 2 ? PaymentSelect : PaymentNormal} width={16} height={16} preview={false} alt=''></Image>
                        <Box sx={{ marginLeft: '8px', width: '52px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', alignContent: 'center' }}>
                            <Image src={IconEwallet} preview={false} width={23} height={23} alt=''></Image>
                        </Box>
                        <Typography fontSize={14} fontWeight={400} color={'#6B6B6B'} paddingLeft={'8px'}>
                            eWallet
                        </Typography>
                    </Box>
                </Box>
            </Grid >
        )
    }

    const fpxAction = () => {
        step2Forms.totalPaymentAmount = ''
        setSelectBank(null)
        setPaymentMethod(1)
        setBankList(step1Data['fpx'] === null ? [] : step1Data['fpx'])
        setBankData(null)
    }

    const ewalletAction = () => {
        step2Forms.totalPaymentAmount = ''
        setSelectBank(null)
        setPaymentMethod(2)
        setBankList(step1Data['ewallet'] === null ? [] : step1Data['ewallet'])
        setBankData(null)
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            backgroundColor: '#FFF8E7',
            paddingTop: '60px',
            paddingBottom: '60px',
            paddingLeft: isDesktop ? '240px' : '12px',
            paddingRight: isDesktop ? '240px' : '12px',
        }}>

            {step === 1 ? step1Item() : step2Item()}

            <Backdrop open={openLoading}>
                <Box>
                    <ReactLoading type={'spokes'} width={'50px'} height={'50px'} color={'#FFFFFF'}></ReactLoading>
                    <Typography fontSize={16} color={'#FFFFFF'} paddingTop={'16px'} textAlign={'center'}>
                        loading...
                    </Typography>
                </Box>
            </Backdrop>
        </Box>
    )
}

// ======================= EXPORT
export default SMOneClickPay
